import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { TipoArquivoFormSelectComponent } from './tipo-arquivo-form-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TipoArquivoFormSelectComponent
    ],
    exports: [
        TipoArquivoFormSelectComponent
    ]
})
export class TipoArquivoFormSelectModule { }
